
const features = [
    "Professional and Experienced Drivers",
    "Modern, Clean, and Well-Maintained Fleet",
    "On-Time Pickups and Reliable Scheduling",
    "Flexible Charter Solutions for Every Need",
    "Competitive and Transparent Pricing",
    "Personalized Service Tailored to Your Requirements",
];

export const WhatSetUsApart = () => {


    return (
        <section className="bg-[#f5f5f5] py-16 lg:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

                    {/* Left Content */}
                    <div>
                        <h2 className="text-4xl md:text-5xl font-semibold text-black">
                            What Sets Us Apart
                        </h2>

                        <p className="mt-6 max-w-3xl mx-auto text-gray-500 text-base md:text-lg leading-relaxed">
                            Every trip is backed by our commitment to safety, reliability,
                            and exceptional customer service.
                        </p>

                        <div className="mt-10 space-y-6">
                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className="flex items-center gap-4"
                                >
                                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-secondryBlue flex items-center justify-center">
                                        <span className="material-symbols-outlined text-white">check</span>
                                    </div>

                                    <p className="font-semibold text-black text-base md:text-lg">
                                        {feature}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Image */}
                    <div>
                        <img
                            src="/images/why_choose_us.png"
                            alt="Charter Bus Passengers"
                            className="
                                w-full
                                h-auto
                                object-cover
                                rounded-[30px]
                                shadow-sm
                            "

                        />
                    </div>

                </div>
            </div>
        </section>
    )
}